<template>
    <div>
        <!-- 问卷 -->
        <el-dialog v-if="!isSmallScreen" top="-15px" :visible.sync="showDialog"
                   width="85%">
            <div class="flex">
                <div class="flex-1  rounded-lg h-150">
                    <div class="container mx-auto p-4  ">
                        <div class="flex items-center mb-4 ">
                            <input type="text"
                                   placeholder="搜索问卷"
                                   v-model="searchQuery"
                                   class="flex-1 p-2 border border-gray-300 rounded-lg focus:border-blue-700  focus:border-2  focus:shadow-md focus:shadow-blue-200 focus:outline-none" />
                        </div>

                        <div class="flex">
                           <!-- <div class="flex flex-col w-36  overflow-y-auto scrollable h-150">
                                <button v-for="item in testClassifyList"
                                        :key="item"
                                        type="button"
                                        class="text-gray-500 text-left mt-2 w-24 p-2 hover:bg-gray-200 rounded-full px-4 text-sm"
                                        :class="{'bg-blue-700 text-white': evaluateSelect === item, ' text-black': evaluateSelect !== item}"
                                        :aria-selected="evaluateSelect === item"
                                        :value="item"
                                        role="tab"
                                        @click="setEvalBtnSelect(item)">

                                    {{ item }}
                                </button>
                            </div>-->
                            <!-- 搜索结果 -->
                            <div class=" overflow-y-auto scrollable w-full h-170">
                                <div class="relative rounded-lg border  border-gray-300 m-2 cursor-pointer "
                                     v-for="item in filteredScales" :key="item._id"
                                     :class="{'text-blue-600 border-b-2  border-indigo-600 shadow-lg': curSelectId === item._id, ' text-black': curSelectId !== item._id}"
                                     :aria-selected="curSelectId === item._id"
                                     @click="setTestCaseSelect(item._id)">
                                    <div class=" border-gray-300 rounded-lg items-left p-1 px-3 text-left text-sm gap-1 ">
                                        <span class="block font-bold mt-1">{{item.Name || '未命名'}}</span>
                                        <!--<img v-if="item.isVip" class="absolute  right-0 top-0" src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/icon/order_vip.svg" style="">-->
                                        <span class="block text-gray-400 mt-1">{{item.Target_audience || '未知受众'}}</span>
                                        <div class="flex justify-between text-gray-300 mt-1">
                                            <span class="ml-0">题目:共{{item.Total_Items || item.Total_items || '0'}}道</span>
                                            <span class="mr-0">已被使用:{{item.usedCount || '0'}}次</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-1 rounded-lg h-150 pr-4">
                    <div class="">
                        <div class="border border-gray-300 rounded-lg shadow-md text-left">
                            <div class="p-4">
                                <h3 class="text-xl  font-semibold">{{showObj.Name || '未选择量表'}}</h3>
                                <div class="text-gray-600 text-sm">{{showObj.English_name || ''}}</div>
                            </div>
                            <div class="mr-2 ml-2 bg-white border-0">
                                <div class="mr-2 ml-2 px-4 py-2 bg-gray-100 rounded-lg">
                                    <div class="mb-4 ">
                                        <div class="flex  flex-col items-left mb-3 ">
                                            <div class="text-[#3F4560] font-bold ">
                                                测评导语
                                                <img src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/subtitle_line_lg.svg" class="w-16 block -mt-1.5" alt="Subtitle Line">
                                            </div>
                                        </div>
                                        <p class="text-gray-700">{{showObj.Introduction || '暂无介绍'}}</p>
                                    </div>

                                    <div class="mb-4">
                                        <div class="flex flex-col items-left mb-3">
                                            <div class="text-[#3F4560] font-bold ">
                                                测评价值
                                                <img src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/subtitle_line_lg.svg"
                                                     class="w-16  block -mt-1.5" alt="Subtitle Line">
                                            </div>
                                        </div>
                                        <p class="text-gray-700 text-sm">{{showObj.core_value || '暂无价值描述'}}</p>
                                    </div>
                                </div>
                                <div class=" pt-4 pb-2 text-gray-400 text-sm">
                                    <div class="mb-1">题目：共{{showObj.Total_Items || showObj.Total_items|| 0}}题</div>
                                    <div>{{showObj.Target_audience || '未知受众'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4 px-2 text-left">
                        <div class="text-sm text-gray-600">量表出处：</div>
                        <div class="text-xs text-gray-300">{{showObj.citation || '暂无出处信息'}}</div>
                    </div>
                </div>
                <div v-if="showObj" class="bg-[url('@/assets/question_bg.png')] flex-1 overflow-y-auto scrollable rounded-lg border border-gray-300 h-[110%]">
                    <!-- 问卷标题和简介 -->
                    <img src="@/assets/question_bg.png" class="h-[180px] w-full"/>
                    <div class="mb-8 question-content">
                        <h1 class="text-2xl font-bold mb-4 p-2">{{ showObj['Name'] }}</h1>
                        <p class="text-gray-600 p-2 text-left">{{ showObj['Instructions'] }}</p>
                    </div>

                    <div class="space-y-6">
                        <div v-for="(question, index) in this.showObj['content']"
                                :key="index"
                                class="p-4 shadow-sm flex flex-col items-start">
                            <h3 class="font-medium mb-2">
                                {{ question.query }}
                                <span class="text-red-500">*</span>
                            </h3>
                            <el-radio v-for="(option, idx) in question.options"
                                        :key="idx"
                                        :label="option"
                                        class="block mb-2">
                                {{ option }}
                            </el-radio>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-end">
                <div class=" flex items-center gap-6 mb-0 mt-2">
                    <div class="text-xs flex items-center gap-2 text-gray-600">
                        <i class="el-icon-warning" aria-hidden="true"></i>
                        请将此链接发给来访者填写,完成后您将收到通知提醒
                    </div>

                    <button v-if="showGenBtn" type="button" class=" bg-blue-600 p-2 mb-0 text-white rounded" @click="genTestUrl">
                        <span class="text-sm">复制测评链接</span>
                    </button>
                    <button v-else class="bg-gray-300 p-2 mb-0 text-white rounded">
                        <span class="text-sm">{{genResult}}</span>
                    </button>
                </div>
            </div>
        </el-dialog>

        <!-- Mobile Version -->
        <el-dialog v-else :visible.sync="showDialog" fullscreen>
            <div class="mobile-question-dialog">
                <!-- Search Bar -->
                <div class="mobile-search-container">
                    <input type="text"
                           placeholder="搜索问卷"
                           v-model="searchQuery"
                           class="mobile-search-input" />
                </div>

                <!-- Category Tabs (Horizontal Scroll) -->
                <!--<div class="mobile-category-tabs">
                    <div class="tabs-scroll-container">
                        <button v-for="item in testClassifyList"
                                :key="item"
                                type="button"
                                class="mobile-tab-btn"
                                :class="{'mobile-tab-btn-active': evaluateSelect === item}"
                                @click="setEvalBtnSelect(item)">
                            {{ item }}
                        </button>
                    </div>
                </div>-->

                <!-- Scale List -->
                <div class="mobile-scale-list">
                    <div class="mobile-scale-item"
                         v-for="item in filteredScales"
                         :key="item._id"
                         :class="{'mobile-scale-item-active': curSelectId === item._id}"
                         @click="setTestCaseSelect(item._id)">
                        <div class="mobile-scale-content">
                            <span class="mobile-scale-title">{{item.Name || '未命名'}}</span>
                            <span class="mobile-scale-audience">{{item.Target_audience || '未知受众'}}</span>
                            <div class="mobile-scale-meta">
                                <span>题目: {{item.Total_Items || item.Total_items || '0'}}道</span>
                                <span>使用: {{item.usedCount || '0'}}次</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Selected Scale Details -->
                <div class="mobile-scale-details" v-if="showObj.Name">
                    <div class="mobile-details-header">
                        <h3 class="mobile-details-title">{{showObj.Name}}</h3>
                        <div class="mobile-details-subtitle">{{showObj.English_name || ''}}</div>
                    </div>

                    <div class="mobile-details-section">
                        <div class="mobile-section-title">
                            测评导语
                            <div class="mobile-title-underline"></div>
                        </div>
                        <p class="mobile-section-content">{{showObj.Introduction || '暂无介绍'}}</p>
                    </div>

                    <div class="mobile-details-section">
                        <div class="mobile-section-title">
                            测评价值
                            <div class="mobile-title-underline"></div>
                        </div>
                        <p class="mobile-section-content">{{showObj.core_value || '暂无价值描述'}}</p>
                    </div>

                    <div class="mobile-details-meta">
                        <div>题目：共{{showObj.Total_Items || showObj.Total_items|| 0}}题</div>
                        <div>{{showObj.Target_audience || '未知受众'}}</div>
                    </div>

                    <div class="mobile-citation">
                        <div class="citation-label">量表出处：</div>
                        <div class="citation-content">{{showObj.citation || '暂无出处信息'}}</div>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="mobile-actions">
                    <div class="mobile-action-note">
                        <i class="el-icon-warning"></i>
                        请将此链接发给来访者填写,完成后您将收到通知提醒
                    </div>

                    <button v-if="showGenBtn"
                            type="button"
                            class="mobile-generate-btn"
                            @click="genTestUrl">
                        复制测评链接
                    </button>
                    <button v-else class="mobile-generate-btn-disabled">
                        {{genResult}}
                    </button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            value: {
                type: Boolean,
                required: true,
            }, vid: {
                type: Number, 
                default: null
            }
        },
        watch: {
            value(newValue) {
                this.showDialog = newValue;
                if (newValue) {
                    this.showGenBtn = true;
                }
            },
        },
        created() {
            this.fetchScales();
        },
        computed: {
            showObj() {
                if (this.curSelectId && this.scaleList.length > 0) {
                    const selectedScale = this.scaleList.find(scale => scale._id === this.curSelectId);
                    console.log('选中的量表:', selectedScale);
                    return selectedScale || {};
                }
                return {};
            },
            filteredScales() {
                const query = this.searchQuery.trim().toLowerCase();
                if (!query) return this.scaleList;

                return this.scaleList.filter(scale => {
                    // 检查所有可能的字段，增加匹配灵活性
                    return scale.Name?.toLowerCase().includes(query) ||
                        scale.Target_audience?.toLowerCase().includes(query) ||
                        scale.Introduction?.toLowerCase().includes(query);
                });
            }
        },
        data() {
            return {
                genResult: null,
                searchQuery: '',
                showGenBtn: false,
                showDialog: false,
                evaluateSelect: "New",
                visitorShowList: [],
                testClassifyList: ["New"],
                moduleDetailInfo: "",

                scaleList: [],
                curSelectId: null, // 初始化为null，避免意外匹配
            };
        },
        methods: {
            async fetchScales() {
                try {
                    const response = await axios.get('/scale-api/v1/get_all_data')
                    if (response.data.code === '00' || response.data.code == 200) {
                        var strRes = response.data.result;
                        this.scaleList = JSON.parse(strRes);
                        console.log("获取到的量表数据:", this.scaleList);

                        // 数据处理和验证
                        this.processScaleData();
                    } else {
                        this.$message.error(response.data.message || '获取量表失败')
                    }
                } catch (error) {
                    console.error('获取量表失败:', error)
                }
            },

            processScaleData() {
                // 确保数据格式一致
                this.scaleList = this.scaleList.map(scale => {
                    // 检查并规范化字段
                    return {
                        ...scale,
                        Name: scale.Name || '未命名量表',
                        Total_Items: scale.Total_Items || 0,
                        Target_audience: scale.Target_audience || '未知受众',
                        usedCount: scale.usedCount || 0,
                    };
                });

                // 设置默认选择
                if (this.scaleList && this.scaleList.length > 0) {
                    this.curSelectId = this.scaleList[0]._id;
                }
            },
            async copyUrl(text) {
                const success = await this.copyToClipboard(text);

                if (!success && !this.fallbackCopyToClipboard(text)) {
                    this.showManualCopyPrompt(text);
                }
                return success;
            },

            async copyToClipboard(text) {
                try {
                    // 检查剪贴板API是否可用
                    if (!navigator.clipboard || !navigator.clipboard.writeText) {
                        return false;
                    }
                    await navigator.clipboard.writeText(text);
                    console.log('文本已复制到剪贴板');
                    return true;
                } catch (err) {
                    console.error('无法使用剪贴板API:', err);
                    return false;
                }
            },
            fallbackCopyToClipboard(text) {
                const textarea = document.createElement('textarea');
                textarea.value = text;
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0'; // 隐藏但不影响选择
                document.body.appendChild(textarea);
                textarea.select();

                try {
                    const successful = document.execCommand('copy');
                    console.log(successful ? '回退方法复制成功' : '回退方法复制失败');
                    return successful;
                } catch (err) {
                    console.error('回退复制失败:', err);
                    return false;
                } finally {
                    document.body.removeChild(textarea);
                }
            },
            showManualCopyPrompt(text) {
                const copyPrompt = document.createElement('div');
                copyPrompt.innerHTML = `
                    <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.7); z-index: 9999; display: flex; justify-content: center; align-items: center;">
                      <div style="background: white; padding: 20px; border-radius: 5px; max-width: 80%;">
                        <p>请手动复制以下链接:</p>
                        <textarea id="manual-copy-text" style="width: 100%; height: 60px; margin-bottom: 10px;">${text}</textarea>
                        <button style="padding: 5px 10px;">关闭</button>
                      </div>
                    </div>
                  `;
                // 添加关闭事件
                const closeBtn = copyPrompt.querySelector('button');
                closeBtn.onclick = () => document.body.removeChild(copyPrompt);

                // 自动选择文本
                const textarea = copyPrompt.querySelector('#manual-copy-text');
                textarea.select();
                document.body.appendChild(copyPrompt);
            },

            async genTestUrl() {
                const token = localStorage.getItem('token');
                if (!token) {
                    this.$message.error('请先登录！');
                    return;
                }

                if (!this.curSelectId || this.curSelectId.length == 0) {
                    this.$message.error('请先选择要生成的问卷！');
                    return;
                }

                this.showGenBtn = false;
                this.genResult = "生成中...";

                try {
                    const payload = { "id": this.curSelectId, "vid": this.vid };
                    const response = await axios.post('/api/generate/questionnaire', payload, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    const url = response.data.url;
                    const copySuccess = await this.copyUrl(url);

                    if (copySuccess) {
                        this.$message.success('复制成功，请将链接发送给来访者。');
                        this.genResult = "生成成功！";
                    } else {
                        this.$message.warning('链接已生成，请手动复制');
                        this.genResult = "生成成功（请手动复制）";
                    }
                    this.$emit('genTestSuccess', url);
                } catch (error) {
                    console.error('生成失败:', error);
                    this.$message.error("生成失败，请稍后重试！");
                    this.genResult = "生成失败，请稍后重试";
                } finally {
                    if (this.genResult.includes('失败')) {
                        setTimeout(() => {
                            this.showGenBtn = true;
                        }, 4000);
                    }
                }
            },
            setTestCaseSelect(selectedCase) {
                if (selectedCase === this.curSelectId) {
                    return;
                }
                this.curSelectId = selectedCase;
            },
            setEvalBtnSelect(selectedBtn) {
                if (selectedBtn === this.evaluateSelect) {
                    return;
                }
                for (const item of this.testClassifyList) {
                    if (item === selectedBtn) {
                        this.evaluateSelect = selectedBtn;
                        //TODO req
                        break;
                    }
                }
            },
        },
    };
</script>
<style>
    @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');
</style>

<style scoped>
    /* Mobile-specific styles */
    .mobile-question-dialog {
        padding: 16px;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .mobile-search-container {
        margin-bottom: 12px;
    }

    .mobile-search-input {
        width: 100%;
        padding: 10px 12px;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        font-size: 14px;
    }

    .mobile-category-tabs {
        margin-bottom: 12px;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .tabs-scroll-container {
        display: flex;
        width: max-content;
        padding-bottom: 4px;
    }

    .mobile-tab-btn {
        padding: 8px 16px;
        margin-right: 8px;
        border-radius: 16px;
        font-size: 13px;
        color: #666;
        background: #f5f5f5;
        border: none;
        white-space: nowrap;
    }

    .mobile-tab-btn-active {
        background: #1a73e8;
        color: white;
    }

    .mobile-scale-list {
        flex: 1;
        overflow-y: auto;
        margin-bottom: 16px;
    }

    .mobile-scale-item {
        padding: 12px;
        margin-bottom: 8px;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
    }

    .mobile-scale-item-active {
        border-color: #1a73e8;
        background-color: #f0f7ff;
    }

    .mobile-scale-content {
        display: flex;
        flex-direction: column;
    }

    .mobile-scale-title {
        font-weight: bold;
        font-size: 15px;
        margin-bottom: 4px;
    }

    .mobile-scale-audience {
        color: #888;
        font-size: 13px;
        margin-bottom: 4px;
    }

    .mobile-scale-meta {
        display: flex;
        justify-content: space-between;
        color: #aaa;
        font-size: 12px;
    }

    .mobile-scale-details {
        background: #f9f9f9;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 16px;
    }

    .mobile-details-header {
        margin-bottom: 16px;
    }

    .mobile-details-title {
        font-size: 18px;
        margin-bottom: 4px;
    }

    .mobile-details-subtitle {
        color: #888;
        font-size: 14px;
    }

    .mobile-details-section {
        margin-bottom: 16px;
    }

    .mobile-section-title {
        font-weight: bold;
        color: #3F4560;
        margin-bottom: 8px;
        position: relative;
    }

    .mobile-title-underline {
        height: 2px;
        width: 40px;
        background: #3F4560;
        margin-top: 4px;
    }

    .mobile-section-content {
        color: #555;
        font-size: 14px;
        line-height: 1.5;
    }

    .mobile-details-meta {
        color: #aaa;
        font-size: 12px;
        margin-top: 12px;
    }

    .mobile-citation {
        margin-top: 12px;
    }

    .citation-label {
        color: #888;
        font-size: 13px;
    }

    .citation-content {
        color: #aaa;
        font-size: 12px;
    }

    .mobile-actions {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .mobile-action-note {
        display: flex;
        align-items: center;
        gap: 6px;
        color: #888;
        font-size: 12px;
    }

    .mobile-generate-btn {
        background: #1a73e8;
        color: white;
        border: none;
        padding: 12px;
        border-radius: 8px;
        font-size: 15px;
    }

    .mobile-generate-btn-disabled {
        background: #e0e0e0;
        color: white;
        border: none;
        padding: 12px;
        border-radius: 8px;
        font-size: 15px;
    }
    .question-dialog-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

</style>